import { getGeolocations } from './helpers'

export const COUNTRY_OR_REGION = 'country_or_region'

export const getInitialValues = targeting => {
  return {
    [COUNTRY_OR_REGION]: getGeolocations(targeting)
  }
}
